import { useState } from 'react'
import type { CustomerProfile } from '../../types'
import type { AddressBookEntry, AddressEditorState } from './addressBookHelpers'
import { emptyEditorState } from './addressBookHelpers'
import { toEditorStateFromAddress } from './addressBookMutations'

type UseAddressEditorInput = {
  profile: CustomerProfile
}

export const useAddressEditor = ({ profile }: UseAddressEditorInput) => {
  const [editorOpen, setEditorOpen] = useState(false)
  const [editingAddressId, setEditingAddressId] = useState<string | null>(null)
  const [editorState, setEditorState] = useState<AddressEditorState>(() => emptyEditorState(profile))
  const [formError, setFormError] = useState('')

  const resetEditor = () => {
    setEditorOpen(false)
    setEditingAddressId(null)
    setEditorState(emptyEditorState(profile))
    setFormError('')
  }

  const startCreateAddress = () => {
    setEditingAddressId(null)
    setEditorState(emptyEditorState(profile))
    setFormError('')
    setEditorOpen(true)
  }

  const startEditAddress = (entry: AddressBookEntry) => {
    setEditingAddressId(entry.id)
    setEditorState(toEditorStateFromAddress(entry))
    setFormError('')
    setEditorOpen(true)
  }

  return {
    editorOpen,
    editingAddressId,
    editorState,
    setEditorState,
    formError,
    setFormError,
    resetEditor,
    startCreateAddress,
    startEditAddress,
  }
}
